import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import useAnimatedNavToggler from "../../helpers/useAnimatedNavToggler.js";

import logo from "../../images/pharmadocx_logo.png";
import { ReactComponent as MenuIcon } from "feather-icons/dist/icons/menu.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortDown } from '@fortawesome/free-solid-svg-icons'

const Header = tw.header`
  flex justify-between items-center
  max-w-screen-xl mx-auto
`;

export const NavLinks = tw.div`inline-block`;

/* hocus: stands for "on hover or focus"
 * hocus:bg-primary-700 will apply the bg-primary-700 class on hover or focus
 */
export const NavLink = tw.a`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500
`;

export const NavDiv = tw.div`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500
`;

export const MobileLink = tw(NavLink)`
  px-8 py-3 rounded bg-primary-500 text-gray-100
`

export const PrimaryLink = tw(NavLink)`
  lg:mx-0
  px-8 py-3 rounded bg-primary-500 text-gray-100
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0
`;

export const LogoLink = styled(NavLink)`
  ${tw`flex items-center font-black border-b-0 text-2xl! ml-0!`};

  img {
    ${tw`w-10 mr-3`}
  }
`;

export const MobileNavLinksContainer = tw.nav`flex flex-1 items-center justify-between`;
export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hocus:text-primary-500 transition duration-300
`;
export const MobileNavLinks = motion(styled.div`
  ${tw`lg:hidden z-10 fixed top-0 inset-x-0 mx-4 my-6 p-8 border text-center rounded-lg text-gray-900 bg-white`}
  ${NavLinks} {
    ${tw`flex flex-col items-center`}
  }
`);

export const DesktopNavLinks = tw.nav`
  hidden lg:flex flex-1 justify-between items-center
`;
// eslint-disable-next-line
export default ({ roundedHeaderButton = false, logoLink, links, className, collapseBreakpointClass = "lg" }) => {
  /*
   * This header component accepts an optionals "links" prop that specifies the links to render in the navbar.
   * This links props should be an array of "NavLinks" components which is exported from this file.
   * Each "NavLinks" component can contain any amount of "NavLink" component, also exported from this file.
   * This allows this Header to be multi column.
   * So If you pass only a single item in the array with only one NavLinks component as root, you will get 2 column header.
   * Left part will be LogoLink, and the right part will be the the NavLinks component you
   * supplied.
   * Similarly if you pass 2 items in the links array, then you will get 3 columns, the left will be "LogoLink", the center will be the first "NavLinks" component in the array and the right will be the second "NavLinks" component in the links array.
   * You can also choose to directly modify the links here by not passing any links from the parent component and
   * changing the defaultLinks variable below below.
   * If you manipulate links here, all the styling on the links is already done for you. If you pass links yourself though, you are responsible for styling the links or use the helper styled components that are defined here (NavLink)
   */
  const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
  const collapseBreakpointCss = collapseBreakPointCssMap[collapseBreakpointClass];

  const defaultLogoLink = (
    <LogoLink href="/">
      <img src={logo} alt="logo" />
      Pharmadocx Consultants
    </LogoLink>
  );
  let [servicesButtonClicked, setServicesButtonClicked] = useState()
  // let servicesButtonClicked = false;
  let toggleServiceMenu = () => {
    console.log("In here");
    setServicesButtonClicked(!servicesButtonClicked);
    // servicesButtonClicked = !servicesButtonClicked;
    console.log(servicesButtonClicked);
  }
  const defaultLinks = [
    <NavLinks key={1}>
      <NavLink onClick={toggleNavbar} href="/about-us">About Us</NavLink>
      <NavLink onClick={toggleNavbar} href="/#our-work" >Our Work</NavLink>
      {/* <NavLink href="/#services" >Services</NavLink> */}
      <NavDiv  className="dropdown" style={{ position: "relative", display: "inline-block" }}>
        <span style={{cursor: "pointer"}} onClick={toggleServiceMenu}>Services<FontAwesomeIcon style={{paddingBottom: "2px", paddingLeft: "3px"}} icon={faSortDown} /></span>
        <div className={`dropdown-content ${!servicesButtonClicked ? "hiddenDropdown" : "gridDropdown"} `} >
        <NavLink onClick={toggleNavbar} style={{marginTop: "5px"}} href="/#services" >All Services</NavLink>
        <hr></hr>
        <NavLink style={{marginTop: "5px"}} href="/Documentation">Documentation</NavLink>
        <NavLink style={{marginTop: "5px"}} href="/DrugLicense">Drug License</NavLink>
        <NavLink style={{marginTop: "5px"}} href="/plantsetup-consultancy">Plant Setup</NavLink>
        <NavLink style={{marginTop: "5px"}} href="/ProjectReport">Project Report</NavLink>
        </div>
      </NavDiv>
      <NavLink onClick={toggleNavbar} href="/blog" >Blog</NavLink>
      <NavLink onClick={toggleNavbar} href="/downloads" >Downloads</NavLink>
      <NavLink onClick={toggleNavbar} href="/contact-us" >Contact Us</NavLink>
      <NavLink target="_blank" href="https://www.youtube.com/channel/UCvFdSapxulg01uGgm6E9Q5A">Youtube</NavLink>
      {/* <MobileLink href="/#">9896133556</MobileLink> */}
      {/* <PrimaryLink tw="lg:ml-12!" css={roundedHeaderButton && tw`rounded-full`}href="/#">+91 9896133556</PrimaryLink> */}
      {/* <PrimaryLink tw="lg:ml-12!" css={roundedHeaderButton && tw`rounded-full`}href="/#">Download Brochure</PrimaryLink> */}
    </NavLinks>
  ];

 

  logoLink = logoLink || defaultLogoLink;
  links = links || defaultLinks;

  return (
    <Header className={className || "header-light"}>
      <DesktopNavLinks css={collapseBreakpointCss.desktopNavLinks}>
        {logoLink}
        {links}
      </DesktopNavLinks>

      <MobileNavLinksContainer css={collapseBreakpointCss.mobileNavLinksContainer}>
        {logoLink}
        <MobileNavLinks initial={{ x: "150%", display: "none" }} animate={animation} css={collapseBreakpointCss.mobileNavLinks}>
          {links}
        </MobileNavLinks>
        <NavToggle onClick={toggleNavbar} className={showNavLinks ? "open" : "closed"}>
          {showNavLinks ? <CloseIcon tw="w-6 h-6" /> : <MenuIcon tw="w-6 h-6" />}
        </NavToggle>
      </MobileNavLinksContainer>
    </Header>
  );
};

/* The below code is for generating dynamic break points for navbar.
 * Using this you can specify if you want to switch
 * to the toggleable mobile navbar at "sm", "md" or "lg" or "xl" above using the collapseBreakpointClass prop
 * Its written like this because we are using macros and we can not insert dynamic variables in macros
 */

const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  }
};
